import { getMainDefinition } from '@apollo/client/utilities';
import type { Operation, GraphQLRequest } from '@apollo/client';

type OperationLike = Operation | GraphQLRequest;

export function isMutation(operation: OperationLike): boolean {
    const definition = getMainDefinition(operation.query);
    return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'mutation'
    );
}

export function isQuery(operation: OperationLike): boolean {
    const definition = getMainDefinition(operation.query);
    return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'query'
    );
}

export function isSubscription(operation: OperationLike): boolean {
    const definition = getMainDefinition(operation.query);
    return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
    );
}
